module.exports = __webpack_public_path__ + "img/success-toast-icon.98848550.svg";